import { Moon, Sun } from "lucide-react";

import { useTheme } from "../context/ThemeContext";

export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const { resolvedTheme, toggleTheme } = useTheme();
  const next = resolvedTheme === "dark" ? "light" : "dark";
  return (
    <button
      type="button"
      className={`icon-button${compact ? " icon-button--compact" : ""}`}
      onClick={toggleTheme}
      aria-label={`Use ${next} theme`}
      title={`Use ${next} theme`}
    >
      {resolvedTheme === "dark" ? <Sun aria-hidden="true" size={19} /> : <Moon aria-hidden="true" size={19} />}
    </button>
  );
}

